import { key } from './constants';

export const clear = () => window.localStorage.removeItem(key);
